import MaterialTable from "@material-table/core";
import TableStyle from "./TableStyle";
import {useIntl} from "react-intl";
import apiRequest from "../services/apiRequest";
import {useState} from "react";
import {createOrderingParams} from "../utils/pagination/ordering";
import {NotificationsContext} from "../ui-components/Notifications";
import {useContext} from "react";
import Spinner from "../ui-components/Spinner";
import {tableIcons} from "@ui-components/TableIcons";
import {getColumns, getExcludeNullColumns} from "../utils/suggestedUsersTableUtils";
import {FormattedMessage} from "react-intl";
const SuggestedUsersTable = ({tableRef, importedFromOptions, excludeNullsRef}) => {

  const intl = useIntl();
  const {push} = useContext(NotificationsContext);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [columns, setColumns] = useState(getColumns(importedFromOptions, excludeNullsRef));

  const createFilteringParams = (query) => {
    const query_filters = query.filters.map((filter) => {
      if (filter.column.pagination){
        return {
          column: filter.column.pagination.column,
          operator: filter.column.pagination.operator,
          value: filter.column.pagination.value_parser(filter.value)
        }
      }else{
        return {
          column: filter.column.field,
          operator: filter.operator,
          value: filter.value
        }
      }
    })
    const excludeNullFilters = Object.entries(excludeNullsRef.current).filter(([key, value]) => value).map(([key, value]) => {
      return {
        column: key,
        operator: "!=",
        value: null
      }
    })
    return [...query_filters, ...excludeNullFilters];
  }

  const buildBody = (query) => {
    const ordering = createOrderingParams(query)
    const filters = createFilteringParams(query)
    let body = {
      limit: query.pageSize,
      offset: query.pageSize * query.page,
    }
    if (filters.length > 0) {
      body.filters = {
        logic: "and",
        filters: filters
      }
    }
    if (ordering) {
      body.ordering = ordering
    }
    return body
  }

  const fetchSuggestedUsers = (query) => {
    const body = buildBody(query)
    return new Promise((resolve, reject) => {
      apiRequest.post("/suggested_users/all", body)
        .then((response) => {
          resolve({
            data: response.items,
            page: query.page,
            totalCount: response.total,
          })
        })
        .catch((e) => {
          push({type: 'error', title: intl.formatMessage({id: 'an_error_occurred'})})
        })
    })
  }

  return (
    <div>
      <TableStyle>
        <MaterialTable
          tableRef={tableRef}
          actions={[
            {
              icon: ()=> {
                return sendingEmail?<Spinner styleType={"white"}/>:<tableIcons.PaperAirplane/>
              },
              tooltip: <FormattedMessage id="send_email"/>,
              onClick: async (event, rowData) => {
                setSendingEmail(true)
                try {
                  await apiRequest.post(`/suggested_users/invite`, {
                      email: rowData.email,
                      firstname: rowData.firstname,
                      lastname: rowData.lastname,
                      address: rowData.address,
                      qualification: rowData.qualification,
                      country: 'it',
                      city: rowData.city,
                      zip_code: rowData.zip_code,
                      phone: rowData.mobile_phone ? rowData.mobile_phone : rowData.phone
                    },
                  )
                  setSendingEmail(false)
                  tableRef.current && tableRef.current.onQueryChange()
                  push({type: 'success', title: intl.formatMessage({id: 'email_sent'})})
                } catch (e) {
                  setSendingEmail(false)
                  push({type: 'error', title: intl.formatMessage({id: 'an_error_occurred'})})
                }
              }
            }]}
          options={{
            paging: true,
            toolbar: false,
            cellStyle: {whiteSpace: "nowrap"},
            headerStyle: {whiteSpace: "nowrap"},
            filtering: true,
          }}
          localization={{
            header: {actions: ""},
            body: {
              editRow: {deleteText: intl.formatMessage({id: "delete_element"})}
            }
          }}
          icons={tableIcons}
          columns={columns}
          data={fetchSuggestedUsers}
        />
      </TableStyle>
    </div>
  )
}

export default SuggestedUsersTable